import axios from 'axios';
import { CITATION_DISCUSSION, CITATION_LANGUAGE, CITATION_SPECIFICALLY, CITATION_SUPPORTING, 
    COVERAGE_CHOICE, COVERAGE_COMMENT, SHORT_CITATION_CODE, SYSTEM_CHOICE,
    REGULATION_CODE, 
    CITATION_LANGUAGE_DELIMETER,
    CONVERT_SQUARE_BRACKET_TO_ARRAY,
    INSPECTION_CODE_TYPE_HAS_NO_SYSTEMCHOICE} from "./constants";

export const getUTCDateTime = () => {
    return (new Date()).toISOString();
};

export const getLocalDateTime = (fromISODateTime) => {
    const localDateTime= new Date(fromISODateTime);
    return `${localDateTime.toLocaleDateString()} ${localDateTime.toLocaleTimeString()}`;
};

export const getLocalDate = (fromISODateTime) => {
    const localDateTime= new Date(fromISODateTime);
    return `${localDateTime.toLocaleDateString()}`;
};

export const getInternationalDate = (fromISODateTime) => {
    const localDateTime= new Date(fromISODateTime);
    return `${localDateTime.toLocaleDateString()}`;
};

export const getGlobalDate = (date) => {
    const localDateTime = new Date(date);
    const day = String(localDateTime.getDate()).padStart(2, '0');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[localDateTime.getMonth()];
    const year = localDateTime.getFullYear();
    return `${day}-${month}-${year}`;
};

export const getDatabaseDate = (date) => {
    // Convert to UTC date
    const convertUTCDate = (new Date(date)).toUTCString();

    // Convert to YYYY-MM-DD format
    var d = new Date(convertUTCDate),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

export const existRegulationWithNoCitation = (regulationCode) => {
    const regulationsWithNoCitation = [ 
        "RE0001", "RE0002", "RE0003", "RE0004", 
        // Summary
        "SM010", "SM011", "SM012", "SM013", "SM014",
        "SM020", "SM021", "SM022",
        "SM030", "SM031", "SM032", "SM033", "SM034", "SM035", "SM036",
        "SM040", "SM041",
        "SM040", "SM041",
        "SM050", "SM051",
        "SM060",
        "SM070", "SM071",
        "SM080",
        "SM090", "SM091", "SM092", "SM093", "SM094", "SM095", "SM096", "SM097", "SM098", "SM099",
        // Pai Drug
        "FDOB010", "FDOB011", "FDOB012", "FDOB013", "FDOB014",
        "FDOB020",
        "FDOB030",
        "FDOB040", "FDOB041", "FDOB042",
        // Pai API
        "APOB010", "APOB011", "APOB012", "APOB013", "APOB014",
        "APOB020",
        "APOB030",
        "APOB040", "APOB041", "APOB042",
        // 503B Operation
        "SM110", "SM111", "SM112", "SM113", "SM114", "SM115", "SM116",
        "SM117", "SM118", "SM119", "SM120", "SM121",

        // 503A Operation
        "SM130", "SM131", "SM132", "SM133", "SM134", "SM135", "SM136",
        "SM137", "SM138", "SM139", "SM140", "SM141",

        // General BIMO
        "SMBIMO010", "SMBIMO020", "SMBIMO030", "SMBIMO040", "SMBIMO050", "SMBIMO060", "SMBIMO070",
        "SMBIMO080", "SMBIMO090", "SMBIMO100", "SMBIMO110", "SMBIMO120", "SMBIMO130", "SMBIMO140",
        "SMBIMO150", "SMBIMO160", "SMBIMO170", "SMBIMO180", "SMBIMO190", 
        "SMBIMO200", "SMBIMO210", "SMBIMO211",
        "SMBIMO220", "SMBIMO230", "SMBIMO240", "SMBIMO250", "SMBIMO260",
        ];
    return regulationsWithNoCitation.includes(regulationCode);
}

// TODO: This is temporary solution, it should be done in backend and load system choice from cfr.csv file.
export const isFoundSystemChoicesBySubPartCode = (subPartCode, systemChoiceName) => {
    const subPartList = {
        SP002: ['Quality', 'Facilities/Equipment', 'Materials', 'Production', 'Packaging/Labeling', 'Laboratory'],
        SP003: ['Facilities/Equipment'],
        SP004: ['Facilities/Equipment'],
        SP005: ['Quality', 'Materials'],
        SP006: ['Quality', 'Production'],
        SP007: ['Quality', 'Packaging/Labeling'],
        SP008: ['Materials'],
        SP009: ['Quality', 'Laboratory'],
        SP010: ['Quality', 'Facilities/Equipment', 'Materials', 'Production', 'Packaging/Labeling', 'Laboratory'],
        SP011: ['Quality', 'Laboratory']
      };

    return subPartList[subPartCode]?.includes(systemChoiceName);
}

// replace citationLanguage '<#>' and [optionLabel|optionFlag] with empty and optionLabel/empty respectively
export const transformCitationLanguage = (citationLanguage)  => {
    let finalCitationLanguage = citationLanguage?.replaceAll(CITATION_LANGUAGE_DELIMETER, '');
    // store citation options in [xyz] pattern into the array
    const citationLanguageOptions = finalCitationLanguage?.match(CONVERT_SQUARE_BRACKET_TO_ARRAY); 
    citationLanguageOptions?.forEach(option => {
        const [optionLabel, optionFlag] = option.replace('[', '').split('|');
        if (optionFlag === '1') {
            finalCitationLanguage = finalCitationLanguage.replace(`${option}]`, optionLabel);
        } else {
            finalCitationLanguage = finalCitationLanguage.replace(`${option}]`, '');
        }
    })
    return finalCitationLanguage; 
}

export const shortenDescription = (description) => {
    const allowedCharacters = 100;
    return description.substring(0, allowedCharacters) + '...';
}

export const populateInspectionSummary = (fieldName, value, inspection) => {

}

export const populateInspectionProtocol = (fieldName, code, value, inspection) => {
    inspection.protocol_quality = inspection.protocol_quality || []; // initialize protocol_quality if null
    let selectedCode = inspection.protocol_quality?.find(item => item?.code === code);

    if (selectedCode) { //Edit mode
        switch (fieldName) {
            case SYSTEM_CHOICE:
                selectedCode = {
                    ...selectedCode,
                    detail: {
                        ...selectedCode.detail,
                        systemChoice: value
                    }
                }
                break;
            case COVERAGE_CHOICE:
                selectedCode = {
                    ...selectedCode,
                    detail: {
                        ...selectedCode.detail,
                        coverageChoice: value
                    }
                }
                break;
            case COVERAGE_COMMENT:
                selectedCode = {
                    ...selectedCode,
                    detail: {
                        ...selectedCode.detail,
                        coverageComment: value
                    }
                }
                break;
            case CITATION_LANGUAGE:
                selectedCode = {
                    ...selectedCode,
                    detail: {
                        ...selectedCode.detail,
                        citationLanguage: value
                    }
                }
                break;
            case CITATION_SPECIFICALLY:
                selectedCode = {
                    ...selectedCode,
                    detail: {
                        ...selectedCode.detail,
                        citationSpecifically: value
                    }
                }
                break;
            case CITATION_SUPPORTING:
                selectedCode = {
                    ...selectedCode,
                    detail: {
                        ...selectedCode.detail,
                        citationSupporting: value
                    }
                }
                break;
            case CITATION_DISCUSSION:
                selectedCode = {
                    ...selectedCode,
                    detail: {
                        ...selectedCode.detail,
                        citationDiscussion: value
                    }
                }
                break;
            case REGULATION_CODE:
                selectedCode = {
                    ...selectedCode,
                    detail: {
                        ...selectedCode.detail,
                        regulationComment: value
                    }
                }
                break;
            default:
                break;
        }
    } else { // Add mode
        switch (fieldName) {
            case SHORT_CITATION_CODE:
                selectedCode = {
                    code: code,
                    detail: {
                        ...selectedCode?.detail
                    }
                }
                break;
            case SYSTEM_CHOICE:
                selectedCode = {
                    code: code,
                    detail: {
                        ...selectedCode?.detail,
                        systemChoice: value
                    }
                }
                break;
            case COVERAGE_CHOICE:
                selectedCode = {
                    code: code,
                    detail: {
                        ...selectedCode?.detail,
                        coverageChoice: value
                    }
                }
                break;
            case COVERAGE_COMMENT:
                selectedCode = {
                    code: code,
                    detail: {
                        ...selectedCode?.detail,
                        coverageComment: value
                    }
                }
                break;
            case CITATION_LANGUAGE:
                selectedCode = {
                    code: code,
                    detail: {
                        ...selectedCode?.detail,
                        citationLanguage: value
                    }
                }
                break;
            case CITATION_SPECIFICALLY:
                selectedCode = {
                    code: code,
                    detail: {
                        ...selectedCode?.detail,
                        citationSpecifically: value
                    }
                }
                break;
            case CITATION_SUPPORTING:
                selectedCode = {
                    code: code,
                    detail: {
                        ...selectedCode?.detail,
                        citationSupporting: value
                    }
                }
                break;
            case CITATION_DISCUSSION:
                selectedCode = {
                    code: code,
                    detail: {
                        ...selectedCode?.detail,
                        citationDiscussion: value
                    }
                }
                break;
            case REGULATION_CODE:
                selectedCode = {
                    code: code,
                    detail: {
                        ...selectedCode?.detail,
                        regulationComment: value
                    }
                }
                break;
            default:
                break;
        }
    }

    inspection.protocol_quality = [...inspection.protocol_quality, selectedCode];

    // remove duplication of selected question in protocol_quality array
    if (inspection.protocol_quality) {
        inspection.protocol_quality = 
            [...inspection.protocol_quality?.reduce((map, obj) => map.set(obj?.code, obj), new Map()).values()]; // This code may cause typing text performance

    }

    return inspection.protocol_quality;
}

export const getDetailByShortCitationCode = (inspection, citation) => {
    const detail = inspection?.protocol_quality?.filter(item => item?.code === citation?.shortcitation_code)[0]?.detail;
    return detail;
}

export const getDetailByRegulationCode = (inspection, citation) => {
    const detail = inspection?.protocol_quality?.filter(item => item?.code === citation?.regulation_code)[0]?.detail;
    return detail;
}

export const getLookupDescriptionByCode = (lookups, code) => {
    const description = lookups?.filter(lookup => lookup.code === code)[0]?.description;
    return description;
}

export const getLookupByCode = (lookups, code) => {
    const lookup = lookups?.filter(lookup => lookup.code === code)[0];
    return lookup;
}

export const getCodeTableDescriptionByCodeTableUid = (codeTables, codeTableUid) => {
    const description = codeTables?.filter(codeTable => codeTable.code_table_uid === codeTableUid)[0]?.description;
    return description;
}

export const getCitationLanguageWithoutPlaceHolder = (citationLanguage) => {
    return citationLanguage?.replaceAll('<#>', '').replaceAll('[', ' ').replaceAll('[', ' ').replaceAll('|0]', ',').replaceAll('|1]', ',');
}

export const handleDownloadFileFromS3 = async (api, s3ObjectKey, fileName, presignUrlDownload) => {
    // setLoading(true);
    try {
        // 1. Get S3 presigned url to download
        const s3PresignedUrlResult = await api.post(presignUrlDownload, {
            objectKey: `${s3ObjectKey}`,
            contentType: "image/jpg"
        });

        // 2. Download file from presigned url
        axios({
            url: s3PresignedUrlResult?.data?.body,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        });
    } catch (error) {
        console.error('Download failed', error);
        // setLoading(false);
    }

    // setLoading(false);
  }

export const setLocalStorage = (key, value) => {
    localStorage.setItem(key, value);
}

export const getLocalStorage = (key) => {
    return localStorage.getItem(key);
}

export const getLastElementStringArray = (str, delimeter) => {
    const last = str.split(delimeter).pop();
    return last;
}

export const citationsHasNoSytemChoice = (questionCitations) => {
    const foundCitationHasNoSystemChoice = questionCitations.some(citation => INSPECTION_CODE_TYPE_HAS_NO_SYSTEMCHOICE.includes(citation?.lookupcodetype))
        
    return foundCitationHasNoSystemChoice;
}


export const convertMessageToHtml = (text) => {
    if (!text) return '';
    
    // Convert markdown-style code blocks (must be done before line breaks)
    text = text.replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>');
    
    // Convert markdown headings (must be done before line breaks)
    text = text.replace(/^######\s+(.+)$/gm, '<h6>$1</h6>');
    text = text.replace(/^#####\s+(.+)$/gm, '<h5>$1</h5>');
    text = text.replace(/^####\s+(.+)$/gm, '<h4>$1</h4>');
    text = text.replace(/^###\s+(.+)$/gm, '<h3>$1</h3>');
    text = text.replace(/^##\s+(.+)$/gm, '<h2>$1</h2>');
    text = text.replace(/^#\s+(.+)$/gm, '<h1>$1</h1>');
    
    // Collapse runs of blank lines so they don't stack into large gaps
    text = text.replace(/\n{3,}/g, '\n\n');

    // Convert bold text
    text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    // Convert italic text
    text = text.replace(/\*(.*?)\*/g, '<em>$1</em>');

    // Convert line breaks
    text = text.replace(/\n/g, '<br>');

    // Headings and code blocks are block elements with their own spacing.
    // Drop any <br> directly adjacent to them so spacing isn't doubled.
    text = text.replace(/(?:<br>\s*)+(<h[1-6]>)/g, '$1');
    text = text.replace(/(<\/h[1-6]>)(?:\s*<br>)+/g, '$1');
    text = text.replace(/(?:<br>\s*)+(<pre>)/g, '$1');
    text = text.replace(/(<\/pre>)(?:\s*<br>)+/g, '$1');

    return text;
};

export const getSortedMarket = (codeTables, allowedMarkets) => {
    return codeTables.filter((codeTable) => codeTable.code_table_type_id === 13 && allowedMarkets.includes(codeTable.code))?.sort((a, b) => {
        // Get the hundreds group for each sort_order
        const aHundreds = Math.floor(a.sort_order / 100) * 100;
        const bHundreds = Math.floor(b.sort_order / 100) * 100;
        
        // If they're in different hundreds groups, sort by sort_order
        if (aHundreds !== bHundreds) {
          return a.sort_order - b.sort_order;
        }
        
        // If either is exactly a hundred (100, 200, 300, etc), it should come first
        if (a.sort_order % 100 === 0) return -1;
        if (b.sort_order % 100 === 0) return 1;
        
        // If they're in the same hundreds group, sort alphabetically by code
        // but only for non-hundred numbers
        return a.description.localeCompare(b.description);
    });
}

// Parse date from database string (YYYY-MM-DD) without timezone conversion
// This prevents the "+1 day" bug when viewing dates in different timezones
export const parseDateWithoutTimezone = (dateString) => {
    if (!dateString) return null;
    if (dateString instanceof Date) return dateString;
    
    // Convert to string if it's not already (handles numbers, etc.)
    const dateStr = String(dateString);
    
    // Extract YYYY-MM-DD from string (handles both "2025-10-14" and "2025-10-14T00:00:00Z")
    const dateOnly = dateStr.split('T')[0];
    const [year, month, day] = dateOnly.split('-').map(Number);
    
    // Validate we have valid date components
    if (!year || !month || !day || isNaN(year) || isNaN(month) || isNaN(day)) {
        console.warn('Invalid date string received:', dateString);
        return null;
    }
    
    // Create date at local midnight (not UTC) to prevent timezone shifts
    return new Date(year, month - 1, day);
}

// Format date for display without timezone conversion
// Uses the browser's locale for proper date formatting (DD/MM/YYYY for AU, MM/DD/YYYY for US, etc.)
export const formatDateWithoutTimezone = (date) => {
    if (!date) return '';
    
    const dateObj = date instanceof Date ? date : parseDateWithoutTimezone(date);
    
    // Check if we got a valid date object
    if (!dateObj || !(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
        console.warn('Invalid date received in formatDateWithoutTimezone:', date);
        return '';
    }
    
    // Use toLocaleDateString() which respects the user's locale
    // This will show DD/MM/YYYY in Australia, MM/DD/YYYY in US, etc.
    return dateObj.toLocaleDateString();
}

// Format dates array or comma-separated string to display format
// Accepts either an array of date strings or a comma-separated string of dates
export const formatDates = (dates) => {
    if (!dates) return "-";
    if (typeof dates === 'string') {
        return dates.split(', ').map(date => getGlobalDate(parseDateWithoutTimezone(date))).join(", ");
    }
    if (Array.isArray(dates)) {
        return dates.map(date => getGlobalDate(parseDateWithoutTimezone(date))).join(", ");
    }
    return "-";
}
